import { useNavigate } from 'react-router-dom';

import { formatDateTime } from '../../../utils';
import { Thumbnail } from '../../Thumbnail/Thumbnail';

import type { EditorResponse } from '../../../types';

import styles from './EditorRow.module.scss';

type Props = {
  editor: EditorResponse;
};

function EditorRow({ editor }: Props) {
  const navigate = useNavigate();

  const { id, name, image, updatedAt } = editor;
  const imageUrl = image ? `${image}?t[]=180q80` : undefined;

  return (
    <tr onClick={() => navigate(`/editors/${id}`)} className={styles.row}>
      <td>
        <Thumbnail
          url={imageUrl}
          isRound
          aspectRatio="1/1"
          className={styles.image}
        />
      </td>
      <td>{name}</td>
      <td>
        <div className={styles.updated}>
          {updatedAt != null && formatDateTime(updatedAt)}
        </div>
      </td>
    </tr>
  );
}

export { EditorRow };
